import PropTypes from 'prop-types'
import React, { PureComponent, Children } from 'react';
import createStore from './create';

class Core extends PureComponent {

    static displayName = '[block] core';

    static propTypes = {
        children : PropTypes.element.isRequired,
        transport: PropTypes.object
    };

    static childContextTypes = {
        transport: PropTypes.object
    };

    getChildContext() {
        return {
            transport: this.props.transport
        };
    }

    render() {
        return Children.only(this.props.children);
    }

}

export { Core as default, createStore }



// WEBPACK FOOTER //
// ./src/blocks/core/index.js